<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="font-family005">Solutions</h2>
            <ul class="font-family005">
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Solutions / Digital Marketing solutions</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area pt-5 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-content">
                    <h2 class="text-capitalize font-family005">Digital Marketing Solutions</h2>
                    <div class="services-content">
                         <div class="services-details-one">
                            <div class="row match-height">
                                <div class="col-12 col-md-12">
                                    <img src="assets/img/product/digi.png" alt="Image" class="fix img-thumbnail">
                                </div>
                                <!-- <div class="col-12 col-md-6">
                                    <img src="assets/img/product/dm3.png" alt="Image" class="fix img-thumbnail">
                                </div> -->
                            </div>
                        </div>
                        <p class="font-family004 pt-3">Solutions marketing focuses its efforts on solutions for customer problems — not the products and services created by its company. Solutions marketing leverages many of the same practices as product marketing but takes the broader focus on business challenges and use cases.</p>
                    </div>

                    <div class="services-content">
                        <h3 class="font-family005 mb-0">Marketing Solutions-Uses</h3>
                        <p class="font-family004">Advanced digital marketing solutions are focused on providing high quality solutions, service and satisfaction of customer. The main strategy behind all this stuff is ultimately to take your business to new heights. It helps in maximizing the revenues.
                        </p>
                    </div>
                    <div class="services-content">
                        <h3 class="font-family005 mb-0">Why is it important?</h3>
                        <p class="font-family004">Marketing Solutions provides a wide range of strategic, creative and production services, all designed to grow your business. Our service bundle can be integrated as a full-service growth program, or as separate services to meet your specific objectives and budgets.</p>
                        <p class="font-family004">Advanced digital marketing solutions have brought a new revolution in the world of digital marketing. Digital marketing solutions provide help to newly opened start up in the initial stage and already setup business in order to make them profitable. It is a victorious situation for both the parties.
                        </p>    
                        <p class="font-family004">Marketing Solutions provides a wide range of strategic, creative and production services, all designed to grow your business.
                           </p>
                        <p class="font-family004">Get cutting-edge insights into consumer behavior, brand perception, and innovation opportunities and make data-driven decisions to optimize marketing spend and personalize customer communication. This will help your company cultivate sustainable growth and outperform competitors.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-sidebar">
                    <div class="services-category">
                        <ul class="font-family004">
                            <li><a routerLink="/smart-card">Smart Card Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/smart-city">Smart City and Safe City <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/vr-ar">VR / AR <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/enterprise-soln">Enterprise Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/marketing-soln">Marketing Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/web-app">Web / Mobile App <i class="bx bx-chevron-right"></i></a></li>
                            <!-- <li><a routerLink="/services-details">Penetration Testing <i class="bx bx-chevron-right"></i></a></li> -->
                        </ul>
                    </div>

                    <div class="services-pdf">
                        <ul class="font-family005">
                            <li><a href="assets/img/BT-CP.pdf"><i class="bx bxs-file-pdf"></i> Company Profile</a></li>
                            <!-- <li><a routerLink="/"><i class="bx bxs-file-doc"></i> DOC Download</a></li> -->
                        </ul>
                    </div>

                    <div class="services-contact mb-30">
                        <h3 class="font-family003">Contact us to do your new projects</h3>
                        <a routerLink="/contact" class="default-btn font-family005"><span>Contact Us</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details Area -->

